import { render, staticRenderFns } from "./Footprint.vue?vue&type=template&id=115a6866&scoped=true"
import script from "./Footprint.vue?vue&type=script&lang=js"
export * from "./Footprint.vue?vue&type=script&lang=js"
import style0 from "./Footprint.vue?vue&type=style&index=0&id=115a6866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a6866",
  null
  
)

export default component.exports